import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { getEpisodeOfCareProgressNotesConnectionId } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-connection"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_updateProgressNoteEpisodeOfCareInput,
  chUpdateProgressNoteEpisodeOfCareMutation,
} from "@/modules/patients/services/ch/__generated__/chUpdateProgressNoteEpisodeOfCareMutation.graphql"
import { chUpdateProgressNoteEpisodeOfCareMutation as chMutation } from "@/modules/patients/services/ch/chUpdateProgressNoteEpisodeOfCareMutation"
import {
  De_updateProgressNoteEpisodeOfCareInput,
  deUpdateProgressNoteEpisodeOfCareMutation,
} from "@/modules/patients/services/de/__generated__/deUpdateProgressNoteEpisodeOfCareMutation.graphql"
import { deUpdateProgressNoteEpisodeOfCareMutation as deMutation } from "@/modules/patients/services/de/deUpdateProgressNoteEpisodeOfCareMutation"

export const useUpdateProgressNoteEpisodeOfCareMutation = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutationWithErrorToast<
    chUpdateProgressNoteEpisodeOfCareMutation & deUpdateProgressNoteEpisodeOfCareMutation
  >(mutation)

  return useCallback(
    (
      input: De_updateProgressNoteEpisodeOfCareInput & Ch_updateProgressNoteEpisodeOfCareInput,
      currentEpisodeId?: string | null,
      onCompleted?: () => void,
    ) => {
      const addConnections: string[] = []
      const removedConnections: string[] = []

      addConnections.push(getEpisodeOfCareProgressNotesConnectionId(input.episodeOfCareId))

      if (currentEpisodeId) {
        removedConnections.push(getEpisodeOfCareProgressNotesConnectionId(currentEpisodeId))
      }

      commit({
        variables: {
          input,
          addConnections,
          removedConnections,
        },
        onCompleted(response) {
          const data = response.updateProgressNoteEpisodeOfCare
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
